import { useEffect, useState } from 'react';

const STORAGE_KEY = 'chigua91:favorites';

const listeners = new Set<() => void>();

const readFavorites = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
};

const writeFavorites = (ids: string[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage errors
  }
  listeners.forEach((listener) => listener());
};

export function useFavorites() {
  const [ids, setIds] = useState<string[]>(() => readFavorites());

  useEffect(() => {
    const sync = () => setIds(readFavorites());
    listeners.add(sync);
    window.addEventListener('storage', sync);
    return () => {
      listeners.delete(sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const isFavorite = (id: string) => ids.includes(id);

  const toggleFavorite = (id: string) => {
    const current = readFavorites();
    const next = current.includes(id)
      ? current.filter((item) => item !== id)
      : [...current, id];
    writeFavorites(next);
  };

  const clearFavorites = () => writeFavorites([]);

  return { ids, isFavorite, toggleFavorite, clearFavorites, count: ids.length };
}